import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {UserContextProvider} from "./Contexts/UserContext";
import {BrowserRouter} from "react-router-dom";
import {createClient, Provider} from "urql";
import {BasketContextProvider} from "./Contexts/BasketContext";
import {SiteDataContextProvider} from "./Contexts/SiteDataContext";

document.body.style.margin = "0";
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
let gqlUrl = '';
if(document.location.hostname=='127.0.0.1'||document.location.hostname=='localhost') {
    gqlUrl = 'http://'+document.location.hostname+':8000/graphql';
} else {
    gqlUrl = 'https://'+document.location.hostname+'/graphql';
}

const client = createClient({
    url: gqlUrl
});



root.render(
  <React.StrictMode>
      <Provider value={client}>
          <SiteDataContextProvider>
      <UserContextProvider>
          <BasketContextProvider>
          <BrowserRouter>
              <App />
          </BrowserRouter>
          </BasketContextProvider>
      </UserContextProvider>
          </SiteDataContextProvider>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
